import { Container, Grid, Text } from '@mantine/core';
import { useForm } from '@mantine/form';
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getManualBySiteId ,getManualByClientId} from '../../store/manageSite/actions';
import CustomModalHeaderTitle from "../../components/common/customModalHeaderTitle";
import { MantineModal } from "../../components/mantine/modal";
import MantineSelect from "../../components/mantine/select";
import ManualCard from '../../components/common/manualbox';
import virginmedia from '../../assets/images/virginmedia.png';
import jbassociate from '../../assets/images/jb-associate.png';
import jblogodarkarrow from '../../assets/images/jb-dark.svg';
import jbdoorimage from '../../assets/images/manuals-default.png';
import { useParams } from 'react-router-dom'; 
import { fetchAllSites,getSitesListbyclientId } from "../../store/actions";

const SiteManuals = () => {
  
  const form = useForm({
    initialValues: {
      site: '',
    }
  });
  
  const dispatch = useDispatch();
  const [searchValue, setSearchValue] = useState<any>('');
  const { siteId } = useParams<{ siteId: string }>(); 
  const { getAllSite } = useSelector((state: any) => ({
     getAllSite: state?.getsiteData?.sitelist,
  }));
  
  const { getsite ,getclient } = useSelector((state: any) => ({
    getsite: state?.getManualURL?.Manualbysite,
    getclient: state?.getManualURL?.Manualbyclient
  }));
  const clientId = typeof window !== 'undefined' ? localStorage.getItem('clientId') : null
  const getSiteList = () => {
    const data = {
      "clientId": clientId,
      "pageNumber": '1',
      "pageSize": '1000',
      "sortColumn": "",
      "sortDirection": "",
      "searchKeyword": searchValue
    }
    dispatch(getSitesListbyclientId(data))
  } 
  useEffect(() => {
    getSiteList();
  }, [dispatch]);
  
  const siteNames = [
    { value: "", label: "All" }, 
    ...getAllSite?.map((site: any) => ({
      value: String(site.siteId),
      label: site.siteName
    })),
  ];

  useEffect(() => {
    if (siteId) {
      setSelectedSite(siteId); 
      getList(siteId); 
    }
  }, [siteId]);
  useEffect(() => {
    if (clientId) {
    getsList(clientId); 
    }
  }, [clientId]);
  const [selectedSite, setSelectedSite] = useState<string | null>(null);
 
  const [selectedManual, setSelectedManual] = useState(null);
  

  const handleSiteChange = (siteId: any) => {
    setSelectedSite(siteId); 
    if (siteId === null||siteId=="") {
     
      dispatch(getManualByClientId(clientId)); 
    } else {
    
      dispatch(getManualBySiteId(siteId)); 
    }
  };
  const getsList = (clientId: string) => {
    dispatch(getManualByClientId(clientId)); 
  };
  const getList = (siteid: string) => {
    dispatch(getManualBySiteId(siteid)); 
  };
  const manualsToShow = selectedSite ? getsite : getclient;

  return (
    <Container size="xl" my="xl" className='max-w-[1240px] w-full'>    
      <Text size="lg" style={{ fontWeight: 500 }} mb="xs">Filter by Site</Text>
      <div className='flex-row flex'>
        <MantineSelect
          placeholder="Select Site"
          data={siteNames}
          value={selectedSite}
          onChange={handleSiteChange} 
          classNames={{ input: 'w-[306px] h-[40px]  bg-white border border-[#B9B9B9] rounded-full opacity-100' }}
        />
      </div>

      <Grid className='mt-8'>
        {manualsToShow?.length > 0 ? (
          manualsToShow.map((manual: any, index: number) => (
            <Grid.Col key={manual?.id || index} span={4}>
              <ManualCard
                number={index + 1}
                manualname={manual.manualName}
                virginImage={virginmedia}
                jbAssociateImage={jbassociate}
                doorImage={jbdoorimage}
                arrowImage={jblogodarkarrow}
                showedit={false}
                showdownload={true}
                item={manual} 
                handleView={() => {
                  setSelectedManual(manual.url); 
                }}
              />
            </Grid.Col>
          ))
        ) : (
          <Grid.Col span={12} style={{ display: 'flex', justifyContent: 'center' }}>
            <Text className="no-drawing-message">No manuals found for the selected site.</Text>
          </Grid.Col>
        )}
      </Grid>
          
    </Container>
  );
};

export default SiteManuals;
